import { withAsync } from '../../behaviors/async';
import Typeahead from '../Typeahead'; // @ts-ignore

export default withAsync(Typeahead);